import styled, { css } from "styled-components";

import { focusOutline } from "core/links";
import { rapidEasing } from "core/animation";
import { regular as regularFontFamily } from "core/fontStyles";
import Close from "core/ReusableIcons/Close";
import ProcessingSpinner from "core/ProcessingSpinner";
import { convertPxToRem } from "frontend/components/helpers";

export const RemoveButton = styled.button`
    cursor: pointer;
    background: transparent;
    margin: 0 0 0 ${convertPxToRem({ px: 8 })};
    padding: 0;
    border: 0;
    line-height: 0;
    font-size: 0;

    // only show focus on keyboard not with mouse:
    &:focus:not(.focus-visible) {
        outline: none;
        box-shadow: none;
        border: none;
    }

    &:focus {
        ${focusOutline}
    }
`;

export const CloseIcon = styled(Close)`
    width: ${convertPxToRem({ px: 12 })};
    height: ${convertPxToRem({ px: 12 })};

    path {
        transition: all ${rapidEasing};
    }
`;

export const ProcessingSpinnerIcon = styled(ProcessingSpinner)`
    width: ${convertPxToRem({ px: 12 })};
    height: ${convertPxToRem({ px: 12 })};
    margin: 0 0 0 ${convertPxToRem({ px: 8 })};
`;

export const TagWrapper = styled.div`
    display: inline-block;
    margin-right: ${convertPxToRem({ px: 16 })};
    margin-top: ${convertPxToRem({ px: 8 })};
    margin-bottom: ${convertPxToRem({ px: 8 })};

    &:last-of-type {
        margin-right: 0;
    }
`;

// Majority of Brand Variations and state of tag happens here
export const TagContainer = styled.div`
    ${regularFontFamily}
    font-size: ${convertPxToRem({ px: 15 })};
    line-height: ${convertPxToRem({ px: 16 })};
    display: inline-flex;
    align-items: center;
    padding: ${convertPxToRem({ px: 6 })} ${convertPxToRem({ px: 16 })};
    cursor: pointer;
    text-decoration: none;

    color: ${({ brandObj }) => brandObj.static.color};
    background: ${({ brandObj }) => brandObj.static.background};

    ${({ isStrikethrough }) =>
        isStrikethrough &&
        css`
            span {
                text-decoration: line-through;
            }
        `}

    ${RemoveButton} {
        ${CloseIcon} path {
            fill: ${({ brandObj }) => brandObj.static.color};
        }
    }

    &:hover {
        text-decoration: none;

        color: ${({ brandObj }) => brandObj.hover.color};
        background: ${({ brandObj }) => brandObj.hover.background};

        ${RemoveButton} {
            ${CloseIcon} path {
                fill: ${({ brandObj }) => brandObj.hover.color};
            }
        }
    }

    ${ProcessingSpinnerIcon} {
        fill: ${({ brandObj }) => brandObj.static.color}
    }

    /* isLink */
    ${({ isLink }) => {
        if (isLink) {
            return css`
                text-decoration: none;
                transition: all ${rapidEasing};

                // only show focus on keyboard not with mouse:
                &:focus:not(.focus-visible) {
                    outline: none;
                    box-shadow: none;
                    border: none;
                }

                &:focus {
                    ${focusOutline}
                }
            `;
        }
    }}

    ${({ isDisabled }) => {
        if (isDisabled) {
            return css`
                /* Should not need pointer events all
                    - only on disable DOM element
                    - divs do not support disabled
                */
                /* pointer-events: all; */
                cursor: not-allowed;

                color: ${({ brandObj }) => brandObj.disabled.color};
                background: ${({ brandObj }) => brandObj.disabled.background};

                &:hover {
                    color: ${({ brandObj }) => brandObj.disabled.color};
                    background: ${({ brandObj }) =>
                        brandObj.disabled.background};

                    ${RemoveButton} {
                        ${CloseIcon} path {
                            fill: ${({ brandObj }) => brandObj.disabled.color};
                        }
                    }
                }

                ${RemoveButton} {
                    cursor: not-allowed;
                    pointer-events: none;

                    ${CloseIcon} path {
                        fill: ${({ brandObj }) => brandObj.disabled.color};
                    }
                }
            `;
        }
    }}
`;
